
import React, { useState, useEffect, useRef } from 'react';
import { Navigation } from '@/components/Navigation';
import { VideoModal } from '@/components/VideoModal';
import { PhotoModal } from '@/components/PhotoModal';
import { WebsiteModal } from '@/components/WebsiteModal';
import { PortfolioItem } from '@/components/PortfolioItem';
import { StatCounter } from '@/components/StatCounter';
import { Footer } from '@/components/Footer';
import { CookieBanner } from '@/components/CookieBanner';
import  HeroSlider  from '@/components/HeroSlider';
import { ClientsSection } from '@/components/ClientsSection';
import { Tabs, TabsContent, TabsList, TabsTrigger } from "@/components/ui/tabs";
import { Button } from "@/components/ui/button";
import { Film, Camera, Image, Globe, Monitor, CheckCircle, ThumbsUp, Heart } from "lucide-react";
import { useLanguage } from '@/hooks/useLanguage';
import { Helmet } from 'react-helmet';

interface PortfolioItemData {
  id: number;
  title: string;
  description: string;
  thumbnail: string;
  type: 'photo' | 'video' | 'website';
  videoUrl?: string;
  websiteUrl?: string;
}

const portfolioItems = [
  {
    id: 1,
    title: 'Yusuf Sahili - Lost in a crowd',
    description: 'Aufnahmen von der Record Release Party in den Hansa Studios',
    loading: 'lazy',
    className: 'transition-all duration-700 ease-in-out opacity-0 animate-fade-in hover:scale-105 hover:brightness-110 hover:shadow-2xl hover:shadow-primary/30 rounded-2xl overflow-hidden',
    type: 'video',
    videoUrl: 'https://www.youtube.com/embed/AZylfWxsiaU',
    thumbnail: 'https://img.youtube.com/vi/AZylfWxsiaU/hqdefault.jpg'
  },
  {
    id: 2,
    title: 'Todesschlucht Torrent de Pareis',
    description: 'Eine Wanderung oder eher Kletterung durch den Torrent de Pareis auf Mallorca.',
    loading: 'lazy',
    className: 'transition-all duration-700 ease-in-out opacity-0 animate-fade-in hover:scale-105 hover:brightness-110 hover:shadow-2xl hover:shadow-primary/30 rounded-2xl overflow-hidden',
    type: 'video',
    videoUrl: 'https://player.vimeo.com/video/1000757934',
    thumbnail: 'https://vumbnail.com/1000757934.jpg'
  },
  {
    id: 3,
    title: 'Schwedenkräuter 2022',
    description: 'A little round trip in south sweden.',
    loading: 'lazy',
    className: 'transition-all duration-700 ease-in-out opacity-0 animate-fade-in hover:scale-105 hover:brightness-110 hover:shadow-2xl hover:shadow-primary/30 rounded-2xl overflow-hidden',
    type: 'video',
    videoUrl: 'https://player.vimeo.com/video/943427947',
    thumbnail: 'https://vumbnail.com/943427947.jpg'
  },
  {
    id: 4,
    title: 'Industriedialog neue Mobilität Sachsen',
    description: 'Short Video of  "Industriedialog neue Mobilität Sachsen" 2023 as promotion for the next years.',
    loading: 'lazy',
    className: 'transition-all duration-700 ease-in-out opacity-0 animate-fade-in hover:scale-105 hover:brightness-110 hover:shadow-2xl hover:shadow-primary/30 rounded-2xl overflow-hidden',
    type: 'video',
    videoUrl: 'https://player.vimeo.com/video/876455713',
    thumbnail: 'https://vumbnail.com/876455713.jpg'
  },
  {
    id: 5,
    title: 'SAFE_Personenleitsystem',
    description: 'Marketingvideo für Studio Hartensteiner in Zusammenarbeit mit Christian Hüller',
    loading: 'lazy',
    className: 'transition-all duration-700 ease-in-out opacity-0 animate-fade-in hover:scale-105 hover:brightness-110 hover:shadow-2xl hover:shadow-primary/30 rounded-2xl overflow-hidden',
    type: 'video',
    videoUrl: 'https://player.vimeo.com/video/845117808',
    thumbnail: 'https://vumbnail.com/845117808.jpg'
  },
  {
    id: 6,
    title: 'Festival of Lights 2022',
    description: 'in Berlin',
    loading: 'lazy',
    className: 'transition-all duration-700 ease-in-out opacity-0 animate-fade-in hover:scale-105 hover:brightness-110 hover:shadow-2xl hover:shadow-primary/30 rounded-2xl overflow-hidden',
    type: 'video',
    videoUrl: 'https://player.vimeo.com/video/769167084',
    thumbnail: 'https://vumbnail.com/769167084.jpg'
  },
  {
    id: 7,
    title: 'Brauereifest 2022',
    description: 'Brauereifest an der alten Börse Marzahn Berlin',
    loading: 'lazy',
    className: 'transition-all duration-700 ease-in-out opacity-0 animate-fade-in hover:scale-105 hover:brightness-110 hover:shadow-2xl hover:shadow-primary/30 rounded-2xl overflow-hidden',
    type: 'video',
    videoUrl: 'https://player.vimeo.com/video/758858246',
    thumbnail: 'https://vumbnail.com/758858246.jpg'
  },
  {
    id: 8,
     title: 'Yusuf Sahili - Disappear',
    description: 'Aufnahmen von der Record Release Party in den Hansa Studios',
    loading: 'lazy',
    className: 'transition-all duration-700 ease-in-out opacity-0 animate-fade-in hover:scale-105 hover:brightness-110 hover:shadow-2xl hover:shadow-primary/30 rounded-2xl overflow-hidden',
    type: 'video',
    videoUrl: 'https://www.youtube.com/embed/btr_rqN4Jrw',
    thumbnail: 'https://img.youtube.com/vi/btr_rqN4Jrw/hqdefault.jpg'
  },
  {
    id: 9,
    title: 'velocity9 - battery rain',
    description: 'concert at wild@heart berlim',
    loading: 'lazy',
    className: 'transition-all duration-700 ease-in-out opacity-0 animate-fade-in hover:scale-105 hover:brightness-110 hover:shadow-2xl hover:shadow-primary/30 rounded-2xl overflow-hidden',
    type: 'video',
    videoUrl: 'https://player.vimeo.com/video/1055937245',
    thumbnail: 'https://vumbnail.com/1055937245.jpg'
  },
  
  // Photos - exactly 9 items
 {
    id: 10,
    title: 'City at Night',
    description: 'The vibrant pulse of urban life captured',
    thumbnail: 'https://images.unsplash.com/photo-1513836279014-a89f7a76ae86?auto=format&fit=crop&w=800&q=80',
    loading: 'lazy',
    className: 'transition-all duration-700 ease-in-out opacity-0 animate-fade-in hover:scale-105 hover:brightness-110 hover:shadow-2xl hover:shadow-primary/30 rounded-2xl overflow-hidden',
    type: 'photo'
  },
  {
    id: 11,
    title: 'Forest Walk',
    description: 'A peaceful journey through untamed nature',
    thumbnail: 'https://images.unsplash.com/photo-1441974231531-c6227db76b6e?auto=format&fit=crop&w=800&q=80',
    loading: 'lazy',
    className: 'transition-all duration-700 ease-in-out opacity-0 animate-fade-in hover:scale-105 hover:brightness-110 hover:shadow-2xl hover:shadow-primary/30 rounded-2xl overflow-hidden',
    type: 'photo'
  },
  {
    id: 12,
    title: 'Abstract Art',
    description: 'Exploring the depths of creative expression',
    thumbnail: 'https://images.unsplash.com/photo-1547891654-e66ed7ebb968?auto=format&fit=crop&w=800&q=80',
    loading: 'lazy',
    className: 'transition-all duration-700 ease-in-out opacity-0 animate-fade-in hover:scale-105 hover:brightness-110 hover:shadow-2xl hover:shadow-primary/30 rounded-2xl overflow-hidden',
    type: 'photo'
  },
  {
    id: 13,
    title: 'Desert Landscape',
    description: 'The stark beauty of arid environments',
    thumbnail: 'https://images.unsplash.com/photo-1473580044384-7ba9967e16a0?auto=format&fit=crop&w=800&q=80',
    loading: 'lazy',
    className: 'transition-all duration-700 ease-in-out opacity-0 animate-fade-in hover:scale-105 hover:brightness-110 hover:shadow-2xl hover:shadow-primary/30 rounded-2xl overflow-hidden',
    type: 'photo'
  },
  {
    id: 14,
    title: 'Urban Explorer',
    description: 'Discovering hidden gems in the cityscape',
    thumbnail: 'https://images.unsplash.com/photo-1477959858617-67f85cf4f1df?auto=format&fit=crop&w=800&q=80',
    loading: 'lazy',
    className: 'transition-all duration-700 ease-in-out opacity-0 animate-fade-in hover:scale-105 hover:brightness-110 hover:shadow-2xl hover:shadow-primary/30 rounded-2xl overflow-hidden',
    type: 'photo'
  },
  {
    id: 15,
    title: 'Mountain Peak',
    description: 'Conquering the heights with breathtaking views',
    thumbnail: 'https://images.unsplash.com/photo-1454496522488-7a8e488e8606?auto=format&fit=crop&w=800&q=80',
    loading: 'lazy',
    className: 'transition-all duration-700 ease-in-out opacity-0 animate-fade-in hover:scale-105 hover:brightness-110 hover:shadow-2xl hover:shadow-primary/30 rounded-2xl overflow-hidden',
    type: 'photo'
  },
  {
    id: 16,
    title: 'Autumn Colors',
    description: 'Fall beautiful palette in full display',
    thumbnail: 'https://images.unsplash.com/photo-1507371341119-452c3f8696b2?auto=format&fit=crop&w=800&q=80',
    loading: 'lazy',
    className: 'transition-all duration-700 ease-in-out opacity-0 animate-fade-in hover:scale-105 hover:brightness-110 hover:shadow-2xl hover:shadow-primary/30 rounded-2xl overflow-hidden',
    type: 'photo'
  },
  {
    id: 17,
    title: 'Tranquil Waters',
    description: 'Reflections on still lakes and peaceful moments',
    thumbnail: 'https://images.unsplash.com/photo-1501785888041-af3ef285b470?auto=format&fit=crop&w=800&q=80',
    loading: 'lazy',
    className: 'transition-all duration-700 ease-in-out opacity-0 animate-fade-in hover:scale-105 hover:brightness-110 hover:shadow-2xl hover:shadow-primary/30 rounded-2xl overflow-hidden',
    type: 'photo'
  },
  {
    id: 18,
    title: 'Wildlife Portrait',
    description: 'Up close with majestic creatures in their habitat',
    thumbnail: 'https://images.unsplash.com/photo-1546182990-dffeafbe841d?auto=format&fit=crop&w=800&q=80',
    loading: 'lazy',
    className: 'transition-all duration-700 ease-in-out opacity-0 animate-fade-in hover:scale-105 hover:brightness-110 hover:shadow-2xl hover:shadow-primary/30 rounded-2xl overflow-hidden',
    type: 'photo'
  },
  
  // Websites - exactly 9 items
    
{
	id: 19,
	title: 'Sounds of Water',
	description: 'Interaktive Citizen-Science-Installation zur Erforschung innerer Bilder beim Hören von Musik.',
	thumbnail: '/images/websites/sow_01.JPG', // ggf. anpassen
	loading: 'lazy',
	className: 'transition-all duration-700 ease-in-out opacity-0 animate-fade-in hover:scale-105 hover:brightness-110 hover:shadow-2xl hover:shadow-primary/30 rounded-2xl overflow-hidden',
	type: 'website',
	websiteUrl: '/sounds-of-water-case-study.html'

  },
  {
    id: 20,
    title: 'Portfolio Website',
    description: 'Showcasing creative work with elegant design',
    thumbnail: 'https://images.unsplash.com/photo-1498050108023-c5249f4df085?auto=format&fit=crop&w=800&q=80',
    loading: 'lazy',
    className: 'transition-all duration-700 ease-in-out opacity-0 animate-fade-in hover:scale-105 hover:brightness-110 hover:shadow-2xl hover:shadow-primary/30 rounded-2xl overflow-hidden',
    type: 'website',
    websiteUrl: 'https://example.com'
  },
  {
    id: 21,
    title: 'Corporate Site',
    description: 'Professional business presence with clear messaging',
    thumbnail: 'https://images.unsplash.com/photo-1454165804606-c3d57bc86b40?auto=format&fit=crop&w=800&q=80',
    loading: 'lazy',
    className: 'transition-all duration-700 ease-in-out opacity-0 animate-fade-in hover:scale-105 hover:brightness-110 hover:shadow-2xl hover:shadow-primary/30 rounded-2xl overflow-hidden',
    type: 'website',
    websiteUrl: 'https://example.com'
  },
  {
    id: 22,
    title: 'Blog Platform',
    description: 'Content-focused design for engaging readers',
    thumbnail: 'https://images.unsplash.com/photo-1499750310107-5fef28a66643?auto=format&fit=crop&w=800&q=80',
    loading: 'lazy',
    className: 'transition-all duration-700 ease-in-out opacity-0 animate-fade-in hover:scale-105 hover:brightness-110 hover:shadow-2xl hover:shadow-primary/30 rounded-2xl overflow-hidden',
    type: 'website',
    websiteUrl: 'https://example.com'
  },
  {
    id: 23,
    title: 'Restaurant Website',
    description: 'Appetizing online presence that drives reservations',
    thumbnail: 'https://images.unsplash.com/photo-1555396273-367ea4eb4db5?auto=format&fit=crop&w=800&q=80',
    loading: 'lazy',
    className: 'transition-all duration-700 ease-in-out opacity-0 animate-fade-in hover:scale-105 hover:brightness-110 hover:shadow-2xl hover:shadow-primary/30 rounded-2xl overflow-hidden',
    type: 'website',
    websiteUrl: 'https://example.com'
  },
  {
    id: 24,
    title: 'Travel Agency Site',
    description: 'Inspiring wanderlust and booking conversions',
    thumbnail: 'https://images.unsplash.com/photo-1517430816045-df4b7de11d1d?auto=format&fit=crop&w=800&q=80',
    loading: 'lazy',
    className: 'transition-all duration-700 ease-in-out opacity-0 animate-fade-in hover:scale-105 hover:brightness-110 hover:shadow-2xl hover:shadow-primary/30 rounded-2xl overflow-hidden',
    type: 'website',
    websiteUrl: 'https://example.com'
  },
  {
    id: 25,
    title: 'Event Landing Page',
    description: 'Driving attendee signups with compelling design',
    thumbnail: 'https://images.unsplash.com/photo-1511578314322-379afb476865?auto=format&fit=crop&w=800&q=80',
    loading: 'lazy',
    className: 'transition-all duration-700 ease-in-out opacity-0 animate-fade-in hover:scale-105 hover:brightness-110 hover:shadow-2xl hover:shadow-primary/30 rounded-2xl overflow-hidden',
    type: 'website',
    websiteUrl: 'https://example.com'
  },
  {
    id: 26,
    title: 'Fitness Studio Website',
    description: 'Energetic and motivational platform for members',
    thumbnail: 'https://images.unsplash.com/photo-1534438327276-14e5300c3a48?auto=format&fit=crop&w=800&q=80',
    loading: 'lazy',
    className: 'transition-all duration-700 ease-in-out opacity-0 animate-fade-in hover:scale-105 hover:brightness-110 hover:shadow-2xl hover:shadow-primary/30 rounded-2xl overflow-hidden',
    type: 'website',
    websiteUrl: 'https://example.com'
  },
  {
    id: 27,
    title: 'Educational Platform',
    description: 'Interactive learning experience with intuitive UX',
    thumbnail: 'https://images.unsplash.com/photo-1501504905252-473c47e087f8?auto=format&fit=crop&w=800&q=80',
    loading: 'lazy',
    className: 'transition-all duration-700 ease-in-out opacity-0 animate-fade-in hover:scale-105 hover:brightness-110 hover:shadow-2xl hover:shadow-primary/30 rounded-2xl overflow-hidden',
    type: 'website',
    websiteUrl: 'https://example.com'
  }
];

const stats = [
  { value: 250, label: "Happy Clients", icon: <Heart className="h-6 w-6" /> },
  { value: 1500, label: "Videos Produced", icon: <Film className="h-6 w-6" /> },
  { value: 5000, label: "Photos Taken", icon: <Camera className="h-6 w-6" /> },
  { value: 150, label: "Web Projects", icon: <Globe className="h-6 w-6" /> }
];

const Index = () => {
  const { t } = useLanguage();
  const [selectedVideo, setSelectedVideo] = useState<{
    title: string;
    videoUrl: string;
  } | null>(null);
  
  const [selectedPhoto, setSelectedPhoto] = useState<{
    title: string;
    photoUrl: string;
    description: string;
  } | null>(null);
  
  const [selectedWebsite, setSelectedWebsite] = useState<{
    title: string;
    websiteUrl: string;
    description: string;
    thumbnail: string;
  } | null>(null);
  
  const [headerAnimationComplete, setHeaderAnimationComplete] = useState(false);
  
  useEffect(() => {
    const timer = setTimeout(() => {
      setHeaderAnimationComplete(true);
    }, 1000);
    
    return () => clearTimeout(timer);
  }, []);

  const scrollToContent = () => {
    const portfolioSection = document.getElementById('portfolio');
    portfolioSection?.scrollIntoView({ behavior: 'smooth' });
  };

  const [modalOpen, setModalOpen] = useState(false);
  const [activeModalItem, setActiveModalItem] = useState<PortfolioItemData | null>(null);
  const handleItemClick = (item: PortfolioItemData) => {
    if (item.type === 'video' && item.videoUrl) {
      console.log("Opening video:", item.title, item.videoUrl);
      setSelectedVideo({
        title: item.title,
        videoUrl: item.videoUrl
      });
    } else if (item.type === 'photo') {
      console.log("Opening photo:", item.title);
      setSelectedPhoto({
        title: item.title,
        photoUrl: item.thumbnail,
        description: item.description
      });
    } else if (item.type === 'website' && item.websiteUrl) {
      console.log("Opening website modal:", item.title);
      setSelectedWebsite({
        title: item.title,
        websiteUrl: item.websiteUrl,
        description: item.description,
        thumbnail: item.thumbnail
      });
    }
  };

  return (
    <>
      <div className="relative min-h-screen">
	  <Helmet>
  <title>Matthias Meyfarth – Videograf, Fotograf & Webdesigner aus Berlin</title>
  <meta name="description" content="Willkommen bei Meyf-Art: Matthias Meyfarth – Ihr Videograf, Fotograf und Webdesigner aus Berlin für kreative visuelle Projekte." />
  <meta property="og:title" content="Startseite | Matthias Meyfarth – Videograf, Fotograf & Webdesigner aus Berlin" />
  <meta property="og:description" content="Entdecken Sie professionelle Videografie, Fotografie und Webdesign von Matthias Meyfarth aus Berlin." />
  <meta property="og:type" content="website" />
</Helmet>
        <section id="home" className="relative h-screen overflow-hidden">
          <HeroSlider onExploreClick={scrollToContent} headerAnimationComplete={headerAnimationComplete} />
        </section>

        <Navigation />

        <main className="relative z-10">
          <section id="portfolio" className="content-section min-h-screen">
            <div className="container mx-auto px-6 py-24">
              <h2 className="text-4xl font-bold mb-8 text-center">{t('Portfolio')}</h2>
              
              <Tabs defaultValue="video" className="w-full">
                <TabsList className="grid w-full max-w-[400px] grid-cols-3 mx-auto mb-8">
                  <TabsTrigger value="video">{t('Videos')}</TabsTrigger>
                  <TabsTrigger value="photo">{t('Photos')}</TabsTrigger>
                  <TabsTrigger value="website">{t('Websites')}</TabsTrigger>
                </TabsList>
                
                <TabsContent value="video" className="space-y-6">
                  <p className="text-center text-lg text-muted-foreground mb-8 max-w-3xl mx-auto">
                    {t('Professional video production services for corporate, promotional, and creative projects')}
                  </p>
                  
                  <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6">
                    {portfolioItems
                      .filter(item => item.type === 'video')
                      .map(item => (
                        <PortfolioItem
                          key={item.id}
                          title={item.title}
                          description={item.description}
                          thumbnail={item.thumbnail}
                          type={item.type}
                          onClick={() => handleItemClick(item)}
                        />
                      ))}
                  </div>
                </TabsContent>
                
                <TabsContent value="photo" className="space-y-6">
                  <p className="text-center text-lg text-muted-foreground mb-8 max-w-3xl mx-auto">
                    {t('High-quality photography capturing moments, landscapes, and commercial subjects with creativity')}
                  </p>
                  
                  <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6">
                    {portfolioItems
                      .filter(item => item.type === 'photo')
                      .map(item => (
                        <PortfolioItem
                          key={item.id}
                          title={item.title}
                          description={item.description}
                          thumbnail={item.thumbnail}
                          type={item.type}
                          onClick={() => handleItemClick(item)}
                        />
                      ))}
                  </div>
                </TabsContent>
                
                <TabsContent value="website" className="space-y-6">
                  <p className="text-center text-lg text-muted-foreground mb-8 max-w-3xl mx-auto">
                    {t('Custom website design and development for businesses of all sizes and industries')}
                  </p>
                  
                  <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6">
                    {portfolioItems
                      .filter(item => item.type === 'website')
                      .map(item => (
                        <PortfolioItem
                          key={item.id}
                          title={item.title}
                          description={item.description}
                          thumbnail={item.thumbnail}
                          type={item.type}
                          onClick={() => handleItemClick(item)}
                        />
                      ))}
                  </div>
                </TabsContent>
              </Tabs>
            </div>
          </section>

          {/* Client Section added here */}
          <section id="clients" className="content-section">
            <ClientsSection />
          </section>

          <section className="content-section py-16 bg-secondary/20">
            <div className="container mx-auto px-6">
              <div className="grid grid-cols-2 md:grid-cols-4 gap-6">
                {stats.map((stat, index) => (
                  <StatCounter
                    key={index}
                    value={stat.value}
                    label={t(stat.label)}
                    icon={stat.icon}
                  />
                ))}
              </div>
            </div>
          </section>

          <section id="services" className="content-section py-24">
            <div className="container mx-auto px-6">
              <h2 className="text-4xl font-bold mb-8 text-center">{t('Services')}</h2>
              <p className="text-xl mb-12 text-muted-foreground max-w-3xl mx-auto text-center">
                {t('How I Can Help Your Business Grow')}
              </p>
              
              <div className="grid grid-cols-1 md:grid-cols-3 gap-8 mt-12">
                <div className="bg-white p-8 rounded-lg shadow-lg hover:shadow-xl transition-shadow">
                  <div className="mb-4 text-primary">
                    <Film className="h-12 w-12" />
                  </div>
                  <h3 className="text-xl font-bold mb-3">{t('Professional Video Production')}</h3>
                  <p className="text-muted-foreground">{t('Videos can increase engagement by up to 80% on your website and social media platforms. With professional videography, your business can showcase products, services, and brand values in a compelling format that connects emotionally with your audience.')}</p>
                </div>
                
                <div className="bg-white p-8 rounded-lg shadow-lg hover:shadow-xl transition-shadow">
                  <div className="mb-4 text-primary">
                    <Camera className="h-12 w-12" />
                  </div>
                  <h3 className="text-xl font-bold mb-3">{t('High-Quality Photography')}</h3>
                  <p className="text-muted-foreground">{t('Professional photography can elevate your brand image and make you stand out from competitors. High-quality visuals are essential for marketing materials, websites, and social media, helping you communicate your brand message effectively and attract more customers.')}</p>
                </div>
                
                <div className="bg-white p-8 rounded-lg shadow-lg hover:shadow-xl transition-shadow">
                  <div className="mb-4 text-primary">
                    <Globe className="h-12 w-12" />
                  </div>
                  <h3 className="text-xl font-bold mb-3">{t('Custom Website Development')}</h3>
                  <p className="text-muted-foreground">{t('A well-designed website serves as your 24/7 digital storefront. By creating responsive, user-friendly websites tailored to your business needs, I help you establish a professional online presence that converts visitors into customers and provides valuable analytics to grow your business.')}</p>
                </div>
              </div>
            </div>
          </section>

          <section id="advantages" className="content-section py-24 bg-secondary/10">
            <div className="container mx-auto px-6">
              <h2 className="text-4xl font-bold mb-8 text-center">{t('Advantages')}</h2>
              <p className="text-xl mb-12 text-muted-foreground max-w-3xl mx-auto text-center">
                {t('Why Choose My Services')}
              </p>
              
              <div className="grid grid-cols-1 md:grid-cols-2 gap-8 mt-12">
                <div className="flex p-6 bg-white rounded-lg shadow-md hover:shadow-lg transition-shadow">
                  <div className="flex-shrink-0 mr-4 text-primary">
                    <CheckCircle className="h-8 w-8" />
                  </div>
                  <div>
                    <h3 className="text-xl font-semibold mb-2">{t('Personalized Approach')}</h3>
                    <p className="text-muted-foreground">{t('I take the time to understand your unique business needs and objectives, ensuring all deliverables are perfectly aligned with your vision and goals.')}</p>
                  </div>
                </div>
                
                <div className="flex p-6 bg-white rounded-lg shadow-md hover:shadow-lg transition-shadow">
                  <div className="flex-shrink-0 mr-4 text-primary">
                    <CheckCircle className="h-8 w-8" />
                  </div>
                  <div>
                    <h3 className="text-xl font-semibold mb-2">{t('Quality Equipment')}</h3>
                    <p className="text-muted-foreground">{t('Using state-of-the-art cameras, lighting, and editing software to ensure the highest quality results for your projects.')}</p>
                  </div>
                </div>
                
                <div className="flex p-6 bg-white rounded-lg shadow-md hover:shadow-lg transition-shadow">
                  <div className="flex-shrink-0 mr-4 text-primary">
                    <CheckCircle className="h-8 w-8" />
                  </div>
                  <div>
                    <h3 className="text-xl font-semibold mb-2">{t('Fast Turnaround')}</h3>
                    <p className="text-muted-foreground">{t('Efficient project management and workflow processes mean you get your content when you need it without sacrificing quality.')}</p>
                  </div>
                </div>
                
                <div className="flex p-6 bg-white rounded-lg shadow-md hover:shadow-lg transition-shadow">
                  <div className="flex-shrink-0 mr-4 text-primary">
                    <CheckCircle className="h-8 w-8" />
                  </div>
                  <div>
                    <h3 className="text-xl font-semibold mb-2">{t('Affordable Packages')}</h3>
                    <p className="text-muted-foreground">{t('Competitive pricing structures designed to fit businesses of all sizes, from startups to established enterprises.')}</p>
                  </div>
                </div>
              </div>
            </div>
          </section>

          <section id="about" className="content-section min-h-screen flex items-center">
            <div className="container mx-auto px-6 py-24">
              <h2 className="text-4xl font-bold mb-8 text-center">{t('About Me')}</h2>
              <p className="text-xl mb-12 text-muted-foreground max-w-3xl mx-auto text-center">
                {t('Crafting Visual Stories with Passion and Precision')}
              </p>
              <div className="grid grid-cols-1 md:grid-cols-2 gap-10 items-center">
                <div>
                  <img 
                    src="/lovable-uploads/d523bcf6-9851-4027-811a-0587d4e7bc20.png" 
                    alt="Videographer" 
                    className="rounded-lg shadow-xl w-full max-w-md mx-auto"
                  />
                </div>
                <div>
                  <p className="text-lg mb-6">
                    {t('My name is Matthias Meyfarth.')}
                  </p>
				  <p className="text-lg mb-6">
                    {t('I\'m a passionate videographer with over 20 years of experience capturing life\'s most precious moments. My journey began with a simple camera, which quickly evolved into a deep love for visual storytelling.')}
                  </p>
                  <p className="text-lg mb-6">
                    {t('Whether I\'m filming weddings, documenting travel adventures, or shooting editorial content, I bring a unique perspective and artistic vision to every project.')}
                  </p>
                  <p className="text-lg">
                    {t('I\'ve had the privilege of collaborating with amazing clients around the world.')}
                  </p>
                </div>
              </div>
            </div>
          </section>
        </main>

        <Footer />

        <VideoModal
          isOpen={!!selectedVideo}
          onClose={() => setSelectedVideo(null)}
          title={selectedVideo?.title || ''}
          videoUrl={selectedVideo?.videoUrl || ''}
        />
        
        <PhotoModal
          isOpen={!!selectedPhoto}
          onClose={() => setSelectedPhoto(null)}
          title={selectedPhoto?.title || ''}
          photoUrl={selectedPhoto?.photoUrl || ''}
          description={selectedPhoto?.description || ''}
        />
        
        <WebsiteModal
          isOpen={!!selectedWebsite}
          onClose={() => setSelectedWebsite(null)}
          title={selectedWebsite?.title || ''}
          websiteUrl={selectedWebsite?.websiteUrl || ''}
          description={selectedWebsite?.description || ''}
          thumbnail={selectedWebsite?.thumbnail || ''}
        />
        
        <CookieBanner />
      </div>
    </>
  );
};

export default Index;
